import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js'
import moment from 'moment'
import Pagination from './../shared/pagination'
import Loader from './../shared/loader'
// import Vue from "vue";
import Vue from "vue";
import JsonExcel from "vue-json-excel";
import download from 'downloadjs';
import printmanifestdetails from './printmanifestdetails.vue'
import {
	BasicSelect
} from 'vue-search-select'
import {
    WebCam
} from "vue-web-cam"
import 'vue-search-select/dist/VueSearchSelect.css'
import common_helper from '../../../common_helper'

Vue.component("downloadExcel", JsonExcel);
import {
	Validator
} from 'vee-validate'
export default {
	name: 'manifestdetails',
	components: {
		BasicSelect,
		Paginate,
		Pagination,
		JsonExcel,
		WebCam,
		download,
		Loader,
		BasicSelect,
		printmanifestdetails
	},
	props: [],
	data() {
		return {
			selectedmerchant: {
				value: '',
				text: ''
			},
			merchantList: [],
			manifeststatus: '',
			limitExeed: false,
			recordLimit: 0,
			show: false,
			download: true,
			dataFilter2: '',
			reportname: '',
			csvFieldsForXls: {},
			listStockReportDataforxls: [],
			listStockReportDatacsv: [],
			csvFields: [],
			isLoading: false,
			// totalRows:0,
			// currentPage: 0,
			totalPage: 0,
			totalRows: 0,
			currentPage: 1,
			pageLimit: 10,
			client: '',
			ClientErr: '',
			WarehouseErr: '',
			clientid: '',
			isError: '',
			warehouse: '',
			warehouseid: '',
			Rubiconmanifestid: '',
			warehousename: '',
			searchchannel: '',
			couriername: '',
			WMSmanifestid: '',
			// pageno: 0,
			// totalPage: 0,
			// pageLimit: 5,
			isError: false,
			showSelectWarehouse: false,
			UILflag: false,
			UidErr: '',
			rubiconidflag: false,
			RubiconErr: '',
			showSelectClient: false,
			showSelectMerchant: false,
			listManifestDetails: [],
			listClientData: [],
			listWarehouseData: [],
			listshippingcompanyData: [],
			channellist: [],
			formattedDate: '',
			listMerchantData: [],
			merchantname: '',
			showparent:true,
			id:0,
			item: {
				value: '',
				text: ''
			},
			listMerchantData1: [{
				value: '',
				text: this.$t('common.selectMerchantPlaceHolder')
			}],
			noofAwbs : 0,
			loading: false,
			selectfileFlag : false,
			isManifestDocUploaded : false,
			cameraSection : false,
			fileSection : false,
			cameraImage : null,
			selectFirstDevice: true,
			screenshotFormat: "image/jpeg",
			playsinline: false,
			autoplay: true,
			imageCaptured : false,
			cameralist : '',
			file :'',
			showfileselect : false,
			showcameraselect : false,
			cameras : '',
			HideDetails:false,
			ShowDeatils:false,
			pickerTransferShow:false,
			manifestImagesUploaded:'',
			isSpoc : false,
			input1 : {},
			spocname : "",
			showmodal : false,
			quantity: '',
		}
	},
	computed: {

	},
	async mounted() {
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.reportname = this.$t('manifestReport.manifestDetails');
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		this.pageNo = 0;
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		// this.getClientList();
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		if (localStorage.getItem("selectedClient")!='undefined')
		{
		this.getMerchantList();
		this.getSalesChannels();
		this.getshippingData();
		}
		this.$root.$on('localStorageChanged', (newValue) => {
			// Update your local data
			this.warehouse = newValue;
			// console.log(newValue+"===============in event")
			// Perform any other actions needed
			this.getshippingData()
		  });
		this.user_type = userdetail.utype;
		this.input1 = ({
                clientid: window.localStorage.getItem("selectedClient")
            });
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				this.showSelectMerchant = true;
				// this.getClientList();
				break;
			case 'client_user':
				this.clientid = userdetail.clientid;
				this.showSelectClient = false;
				this.showSelectWarehouse = true;
				this.showSelectMerchant = true;
				// this.getWarehouseList();
				this.getMerchantList();
				// this.getManifestData();
				break;
			case 'warehouse_user':
				this.warehouseid = userdetail.warehouseid;
				this.showSelectClient = true;
				this.showSelectMerchant = true;
				this.showSelectWarehouse = false;
				// this.getClientList();
				break;
			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}
		this.getRecordLimit()
        let checkIsSpoc = await common_helper.getRestApiResponse('POST', 'checkClientSpocFlagList',  this.input1, this.$alertify);
		if(checkIsSpoc.data.data.spokenabled)
		{
			this.isSpoc = true;
		}
	
	},
	filters: {
		moment: function(date) {
			return moment(date).format('DD-MM-YYYY');
		}
	},
	methods: {
		showchild(id){
			this.showparent=false
			this.id=id

		},
		uploaddocument(manifestid){
			this.id=manifestid
			this.HideDetails=true,
			this.ShowDeatils=true,
			this.pickerTransferShow=true
		},
		showParent(){
			this.showparent=true
		},
		reset() {
			this.item = {}
		},
		onSelect(item) {
			// select option from parent component
			this.item = item
			this.merchantname = item.value;

		},
		selectMerchant(data) {
			this.selectedmerchant = data;
			this.merchantname = data.value;
		},
		isNumeric: function(n) {
			return !isNaN(parseFloat(n)) && isFinite(n);
		}, //To Get Channel List

		chooseUpload(){
            this.selectfileFlag = true;
		},
		uploadManifestImage(uploadType){
			if(uploadType == 'file')
			{
				this.fileSection = true;
				this.cameraSection = false;
			}
			else{
				this.fileSection = false;
				this.cameraSection = true;
			}
		},
		cameraSelected() {
            this.$refs.cameraImage.changeCamera(this.cameralist)
        },

        camerass(camlist) {
            this.cameras = camlist
        },
		captureImage() {
            this.$refs.cameraImage.pause()
            this.imageCaptured = true
        },
        resetImage() {
            this.imageCaptured = false
            this.$refs.cameraImage.resume()
        },
		async saveImage(inputtype) {
            try {

                this.showfileselect = false
                this.showcameraselect = false
                if (!this.imageCaptured && inputtype == 'camera') {
                    this.$alert(this.$t('grcList.captureImg'))
                    return false
                } else if (!this.file && inputtype == 'file') {
                    this.$alert(this.$t('grcList.selectImg'))
                    return false
                }
                if (inputtype == 'file') {
                    var imgpath = document.getElementById('file');
                    if (!imgpath.value == "") {
                        var img = imgpath.files[0].size;
                        var imgsize = img / 1024;
                        if (imgsize > 4000) {
                            this.$alert(this.$t('grcList.imgSize4mbErr'))
                            document.getElementById('file').value = null
                            this.file=null
                            return false;
                        }
                    }
                }
                let imageString = ""
                var userToken = window.localStorage.getItem('userToken')
                var myStr = userToken.replace(/"/g, '');
                if (inputtype == "camera") {
                    imageString = this.$refs.cameraImage.capture()
                    if (!common_helper.calculateImageSize(imageString)) {
                        this.$alert(this.$t('grcList.imgSize4mbErr'))
                        this.isLoading = false
                        imageString = ""
                        return false
                    }
                } else {
                    let reader = new FileReader()
                    reader.readAsDataURL(this.file)
                    imageString = await new Promise((resolve, reject) => {
                        reader.onload = function() {
                            this.base64String = reader.result.replace("", "")
                            resolve(this.base64String)
                        }
                    })
                }
                let inputpayload = {
                    clientid : this.client,
					manifestid :  this.id,
					imagestring : imageString
                }
                this.isLoading = true
                let Result = await common_helper.getRestApiResponse('POST', 'UploadImageforManifest', inputpayload, this.$alertify)
				if(Result.data.data.status == true){
					this.$alertify.success("Image Uploaded Successfully");
					this.isLoading = false;
					this.cameraSection = false;
					this.fileSection = false;
					this.selectfileFlag = false;
					this.HideDetails = false;
					this.ShowDeatils = false;
					this.pickerTransferShow = false;
					this.isManifestDocUploaded = true;
					this.getManifestSearch(2)
					document.getElementById('file').value = null
				}
            } catch (err) {
				document.getElementById('file').value = null
                console.log(err)
            }
        },
		closeHandoverModal(){
			this.pickerTransferShow = false;
			this.ShowDeatils = false;
			this.cameraSection = false;
			this.fileSection = false;
			this.imageCaptured = false;
			//document.getElementById('file').value = '';
			//document.body.classList.remove('modal-open');
			//document.body.classList.remove('modal-backdrop');

		},
		handleFileUpload() {
            this.file = this.$refs.file.files[0];
            let imageTypes = ['image/jpeg', 'image/png']
            let imageFormat = this.file.type
            let checkFormat = imageTypes.includes(imageFormat)
            if (!checkFormat) {
                this.file = null
                document.getElementById('file').value = null
                this.$alert(this.$t('grcList.imgFormatErr'))
            }
        },

		getRecordLimit() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({

			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getRecordLimit',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result.data) {
						this.recordLimit = result.data.data;


					}
				}, error => {
					console.error(error)
				})
		},
		Choosetype() {
			this.show = true;
			this.download = false;
			this.getManifestDataForXls(3)
		},
		jsonToCSV(filename, data, csvfield, dateFilter = [], skipFilter = [], dataFilter) {
			var csvData = '';
			//Header
			if (this.title != null) {
				csvData += this.parseExtraData(this.title, '${data}\r\n')
			}
			//Fields
			csvData += ''
			Object.entries(dataFilter).forEach(([k, v]) => {
				csvData += k + ':' + v + ','
			})
			csvData += '\r\n'
			csvData += '\r\n'

			for (let key in data[0]) {
				if (skipFilter.indexOf(key) == -1)
					csvData += csvfield[key] + ',';
			}
			csvData = csvData.slice(0, csvData.length - 1);
			csvData += '\r\n';
			//Data
			data.map(function(item) {
				for (let key in item) {
					if (skipFilter.indexOf(key) == -1) {
						var escapedCSV = item[key] + ''; // cast Numbers to string
						if (escapedCSV.match(/[,"\n]/)) {
							escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"';
						}
						if (escapedCSV == 'null')
							csvData += ',';
						else {
							if (dateFilter.indexOf(key) != -1)
								csvData += moment(escapedCSV).format('DD-MM-YY HH:mm:ss') + ',';
							else
								csvData += escapedCSV + ',';
						}
					}
				}
				csvData = csvData.slice(0, csvData.length - 1);
				csvData += '\r\n';
			})
			//Footer
			if (this.footer != null) {
				csvData += this.parseExtraData(this.footer, '${data}\r\n');
			}
			filename += moment().format('DD-MM-YY HH:mm:ss') + '.csv';
			return this.export(csvData, filename, "application/csv");
			return csvData;
		},
		export (data, filename, mime) {
			let blob = this.base64ToBlob(data, mime)
			download(blob, filename, mime)
		},

		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
			let bstr = atob(base64)
			let n = bstr.length
			let u8arr = new Uint8ClampedArray(n)
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n)
			}
			return new Blob([u8arr], {
				type: mime
			})
		},
		getSalesChannels() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			if (this.clientid == '') {
				this.WarehouseErr = this.$t('srReport.clientError');
				return false;
			}
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'orderSalesChannelList',
					'data': {
						clientid: this.clientid
					},
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					this.channellist = result.data.data;
				}, error => {
					console.error(error);
				});
		},
		onSubmit: function() {
			this.$validator.validateAll().then(() => {
				console.log('form is valid', this.model)
			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		},
		// To Get Shipping list
		getshippingData() {
			if (localStorage.getItem("selectedClient") == '') {
				this.ClientErr = this.$t('common.clientError');
				return false;
			}
			if (localStorage.getItem("selectedWarehouse") == '') {
				this.ClientErr = this.$t('common.warehouseError');
				return false;
			}
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			if (this.user_type == 'warehouse_user') {
				this.warehouseid = this.warehouseid;
			}
			if (localStorage.getItem("selectedClient") == '') {
				return false;
			}
			this.totalRows = 0
			this.listManifestDetails = []
			this.input = ({
				clientid: localStorage.getItem("selectedClient"),
				warehouseid: window.localStorage.getItem("selectedWarehouse"),
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'shippingDetails',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.listshippingcompanyData = result.data.data;
					this.getSalesChannels();
				}, error => {
					console.error(error)
				})
		},
		getMerchantList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: localStorage.getItem("selectedClient"),
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'merchantList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result.data && result.data.length > 0) {
						this.listMerchantData = result.data;
						this.item = {
								value: '',
								text: ''
							},
							this.listMerchantData1 = [{
								value: '',
								text: this.$t('common.selectMerchantPlaceHolder')
							}]
						this.listMerchantData.forEach(ele => {
							this.listMerchantData1.push({
								"value": ele.merchantid,
								"text": ele.merchantname

							})
						})

					}
				}, error => {
					console.error(error)
				})
		},
		//to get clientlist
		// getClientList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 		this.getshippingData();
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.input = ({
		// 			warehouseid: this.warehouseid,
		// 		});
		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr,
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 				this.getshippingData();
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },
		// // To Get Warehouse list
		// getWarehouseList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});
		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },
		// //on change of client
		// clientSelected() {
		// 	if (this.clientid != this.client) {
		// 		this.totalRows = 0
		// 		this.listManifestDetails = []
		// 		this.merchantList = []
		// 		this.selectedmerchant = {}
		// 		this.clientid = this.client;
		// 		this.merchantname = '';
		// 		if(this.user_type!="warehouse_user"){
		// 			this.warehouseid='';
		// 			this.getWarehouseList();
		// 		}

		// 		if (this.clientid) {
		// 			this.getWarehouseList();
		// 			this.getMerchantList();
		// 		}
		// 	}
		// },
		getManifestSearch() {
			this.currentPage = 1;
			this.getManifestData();
		},
		//get Manifest list
		getManifestData(csvCheck = 0) {
			if (csvCheck !== 1) {
				this.download = true;
				this.show = false;
				this.limitExeed = false
			}
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var dataFilter = {};
			this.searchFlag = true;
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
				this.limitExeed = false;
			}
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				this.ClientErr = this.$t('common.clientError');
				this.pageNo = this.totalPage = 0;
				this.listManifestDetails = [];
				return false;
			}
			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.WarehouseErr = this.$t('common.warehouseError');
				this.pageNo = this.totalPage = 0;
				this.listManifestDetails = [];
				return false;
			}

			this.isLoading = true

			this.input = ({
				offset: (this.currentPage - 1) * 5,
				limit: this.pageLimit,
				postdatadocumentno: this.Rubiconmanifestid.trim(),
				id: this.WMSmanifestid.trim(),
				clientid: localStorage.getItem("selectedClient"),
				warehouseid: window.localStorage.getItem("selectedWarehouse"),
				courier_name: this.couriername,
				channel_name: this.searchchannel,
				manifeststatus: this.manifeststatus,
				isimagesuploaded: this.manifestImagesUploaded,
				merchantid: this.merchantname,
				csvData: csvCheck,
			})
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getManifestDetailsList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (csvCheck == 1) {
						if (result.data.data.length > 0) {
							this.show = true;
							this.download = false;
							this.listStockReportDataCsv = [];

							this.csvFields = {
								'postdatadocumentno': this.$t('manifestReport.rubiconManifestId'),
								'id': this.$t('manifestReport.wmsManifestId'),
								'count': this.$t('manifestReport.noOfAwb'),
								'courier_name': this.$t('common.courierName'),
								'channel_name': this.$t('common.channelName'),
								'merchantname': this.$t('common.merchantName'),
								'vehicle_no': this.$t('manifestReport.table.columns.vehicleNo'),
								'handover_person': this.$t('manifestReport.table.columns.handoverPerson'),
								'manifest_status':this.$t('manifestReport.table.columns.manifestStatus'),
								'created_at': this.$t('common.createdDate'),
								'ispatchdocument': this.$t('manifestReport.ispatchDocument'),
								'ispostdocument': this.$t('manifestReport.ispostDocument'),
								'warehouseid': this.$t('common.warehouseID'),

							};
							var dateFilder = [];
							var skipFilter = ['shippingprovider'];
							this.listStockReportDataCsv = result.data.data;
							this.jsonToCSV(this.$t('manifestReport.manifestDetails')+ moment().format('DD-MM-YY_HH-mm-ss'), this.listStockReportDataCsv, this.csvFields, dateFilder, skipFilter, dataFilter);
						} else {
							if (result.data.status == true) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}
					} else {
						this.listManifestDetails = result.data.data
						this.totalRows = result.data.count
						if (Number(this.totalRows) > Number(this.recordLimit)) {
							this.limitExeed = true
						}
						if (result.data.errorCode == -1) {
							this.totalPage = 0;
						} else {
							this.totalRows = result.data.count
							if (this.totalRows <= this.pageLimit) {
								this.totalPage = 1
							} else {
								this.totalPage = Math.ceil(this.totalRows / this.pageLimit);
							}
						}
					}

					this.isLoading = false


				}, error => {
					console.error(error)
				})
		},
		getManifestDataForXls(csvCheck = 3) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.show = true;
			this.download = false;
			this.dataFilter2 = [];
			var value = '';
			var str = '';


			this.isLoading = true

			this.input = ({
				offset: (this.currentPage - 1) * 5,
				limit: this.pageLimit,
				postdatadocumentno: this.Rubiconmanifestid.trim(),
				id: this.WMSmanifestid.trim(),
				clientid: localStorage.getItem("selectedClient"),
				warehouseid:  window.localStorage.getItem("selectedWarehouse"),
				courier_name: this.couriername,
				channel_name: this.searchchannel,
				manifeststatus: this.manifeststatus,
				csvData: csvCheck,
				merchantid: this.merchantname,

			})
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getManifestDetailsList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (csvCheck == 3) {
						if (result.data.data.length > 0) {
							this.listStockReportDataforxls = [];
                            this.csvFieldsForXls[ this.$t('manifestReport.rubiconManifestId')]='postdatadocumentno';
                            this.csvFieldsForXls[ this.$t('manifestReport.wmsManifestId')]='id';
                            this.csvFieldsForXls[ this.$t('manifestReport.noOfAwb')]='count';
                            this.csvFieldsForXls[ this.$t('common.courierName')]='courier_name';
                            this.csvFieldsForXls[ this.$t('common.channelName')]='channel_name';
                            this.csvFieldsForXls[ this.$t('common.merchantName')]='merchantname';
                            this.csvFieldsForXls[ this.$t('manifestReport.table.columns.vehicleNo')]='vehicle_no';
                            this.csvFieldsForXls[ this.$t('manifestReport.table.columns.handoverPerson')]='handover_person';
                            this.csvFieldsForXls[ this.$t('manifestReport.table.columns.manifestStatus')]='manifest_status';
                            this.csvFieldsForXls[ this.$t('common.createdDate')]='created_at';
                            this.csvFieldsForXls[ this.$t('manifestReport.ispatchDocument')]='ispatchdocument';
                            this.csvFieldsForXls[ this.$t('manifestReport.ispostDocument')]='ispostdocument';
                            this.csvFieldsForXls[ this.$t('common.warehouseID')]='warehouseid';
							this.listStockReportDataforxls = result.data.data;
						} else {
							if (result.data.status == true) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}


					}
					this.isLoading = false


				}, error => {
					console.error(error)
				})
		},
		//to paginationate data
		// getPaginationData(currentPage) {
		//   this.pageno = (currentPage - 1) * this.pageLimit;
		//
		//   this.getManifestData();
		// },
		onPageChange(page) {
			this.currentPage = page;
			this.getManifestData()
		},
		//to reset form
		resetflt() {

			this.item = {
				value: '',
				text: ''
			};
			this.manifeststatus = ''
			this.manifestImagesUploaded = ''
			// this.listMerchantData1 = [{
			// 	value: '',
			// 	text: this.$t('common.selectMerchantPlaceHolder')
			// }];
			this.show = false;
			this.download = true;
			this.totalRows = 0
			this.searchchannel = '';
			this.couriername = '';
			this.WMSmanifestid = '';
			this.Rubiconmanifestid = '';
			this.merchantname = ''
			// this.merchantList = []
			this.selectedmerchant = {}
			this.warehouseid = '';
			this.client = '';
			this.clientid ='';
			if (this.user_type == 'client_user') {
				this.warehouseid = '';
				// this.warehouse = '';

			} else if (this.user_type == 'system_user') {
				this.warehouseid = '';
				this.warehouse = '';
				this.clientid = '';
				this.client = '';
			} else if (this.user_type == 'warehouse_user') {
				this.clientid = '';
				this.client = '';
			}
			this.listManifestDetails = [];
			this.pageNo = 0;
			this.totalPage = 0;
			this.WarehouseErr = '';
			this.ClientErr = '';
		},
		async getHandoverPDF(manifestid){
			try {
				const userToken = window.localStorage.getItem('userToken')
				const myStr = userToken.replace(/"/g, '');
				this.isLoading = true;
				this.input = ({
					clientid: localStorage.getItem("selectedClient"),
					manifestid: manifestid
				});
				const result = await axios({
					method: 'POST',
					'url': apiUrl.api_url + 'generatepdfImagesManifest',
					'data': this.input,
					headers: {
						'Content-Type': 'application/json',
						'Authorization': 'Bearer ' + myStr
					}
				})
				if (result.data && result.data.status) {
					window.open(result.data.pdfUrl, "_blank");
				}else{
					this.$alertify.error(this.$t('manifestReport.noDocumentFound'))
				}
				this.isLoading = false;
			} catch (error) {
				this.isLoading = false;
				this.$alertify.error('Some Error Occured. Please Try Again.')
				//this.$alertify.error(this.$t('apiErrors.SOME_ERR_OCCURED'))
				console.error(error)
			}
		},
		openmodal(data) {
			this.spocname = data;
			//document.getElementById('quantity').disabled = true;
			this.showmodal = true;
			
			this.$nextTick(() => {
				this.$validator.reset();
				this.errors.clear();
			});
		},
		closemodal() {
			this.quantity = '';
			document.getElementById('quantity').value = "";
			this.$validator.reset();
			this.errors.clear();
			this.showmodal = false;
			this.$nextTick(() => {
				document.body.classList.remove('modal-open');
				document.body.style.removeProperty('padding-right');

				const backdrops = document.getElementsByClassName('modal-backdrop');
				while (backdrops.length > 0) {
					backdrops[0].parentNode.removeChild(backdrops[0]);
				}
			});
		},
		submitprint() {
			var qty = this.quantity;
			if(qty > 1000){
				this.quantity = 1000
				this.$alertify.error(this.$t('editedjson.printQtyvalidation'));
				return false;
			}
			this.printSPocSticker(this.spocname,qty)
		},
		async printSPocSticker(spocname,qty)
		{
            var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				spocname :spocname,
				qty: qty
			});

			axios({
					method: 'POST',
					'url': apiUrl.api_url +'generateSPOCNameSlip',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					},
					responseType:"blob"
				})
				.then(result => {
					if (result.data) {
						const file = new Blob([result.data], { type: "application/pdf" });
						//Build a URL from the file
						const fileURL = URL.createObjectURL(file);
						//Open the URL on new Window
						 const pdfWindow = window.open();
						 pdfWindow.location.href = fileURL;
						this.$alertify.success(this.$t('editedjson.printSuccess'));
						this.closemodal();
					} else {
						this.closemodal();
					}
				}, error => {
					this.isLoading = false;
					console.error(error)
				})
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/components/manifestdetails/manifestdetails.component.js